import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-040f5ece"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "box-content"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "bottom-box"
};
var _hoisted_4 = {
  class: "right-content"
};
var _hoisted_5 = {
  class: "view-count"
};
var _hoisted_6 = {
  class: "thumb-count"
};
var _hoisted_7 = {
  class: "left-content"
};
var _hoisted_8 = {
  class: "user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_EyeOutlined = _resolveComponent("EyeOutlined");
  var _component_LikeOutlined = _resolveComponent("LikeOutlined");
  var _component_a_avatar = _resolveComponent("a-avatar");
  return _openBlock(), _createElementBlock("div", {
    class: "card-container",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.onCardClick && _ctx.onCardClick.apply(_ctx, args);
    })
  }, [_createElementVNode("div", {
    class: "cover-container hover-image",
    style: _normalizeStyle("background-image: url(".concat(_ctx.work.userCreationCover, ")"))
  }, null, 4), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.work.userCreationTitle), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_EyeOutlined, {
    class: "icon-view-count"
  }), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.viewCount), 1), _createVNode(_component_LikeOutlined, {
    class: "icon-thumb-count"
  }), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.thumbCount), 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_avatar, {
    class: "user-avatar",
    src: _ctx.work.userAvatar,
    size: "small",
    alt: "avatar"
  }, null, 8, ["src"]), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.work.userName), 1)])])])]);
}